import { createFileRoute, redirect } from '@tanstack/react-router';
import { useCatalogoStore } from '@/features/catalogo/store/store';

export const Route = createFileRoute('/p/catalogo/$slug/_default/usuario')({
    beforeLoad: ({ params }) => {
        const { isUserLogged, getTokenStatus } = useCatalogoStore.getState();

        if (!isUserLogged() || getTokenStatus().status === 'expired') {
            throw redirect({ params, to: '/p/catalogo/$slug/auth/entrar' });
        }
    },
});
